<ng-container *transloco="let t; read: 'configuration'">
<div class="rounded-lg fixActionRow">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{title}}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content class="relative">
    <form class="grid grid-cols-2 gap-x-10 py-6" [formGroup]="agencyForm">
      <div class="col-span-2 items-center w-[100%]">
        <div class="flex items-center justify-between">
          <label class="font-normal required" for="agencyName">{{ t('agencies.fields.agencyName') }}</label>
          <div class="flex items-center gap-8">
            <mat-checkbox formControlName="isActive"><span class="font-normal text-base whitespace-nowrap">{{ t('agencies.fields.activeAgency') }}</span></mat-checkbox>
            <mat-checkbox formControlName="isTestAgency"><span class="font-normal text-base whitespace-nowrap">{{ t('agencies.fields.testAgency') }}</span></mat-checkbox>
          </div>
        </div>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('agencies.fields.agencyName')" autocomplete="off" id="agencyName" type="text"
            formControlName="agencyName" maxlength="100" required>
        </mat-form-field>
      </div>

      <div class="col-span-2 items-center w-[100%]">
        <label class="font-normal" [class.required]="stateId?.value == states.california"
          for="vendorNumber">{{ t('agencies.fields.vendorNumber') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('agencies.fields.vendorNumber')" autocomplete="off" id="vendorNumber" type="text"
            formControlName="vendorNumber" maxlength="19">
        </mat-form-field>
      </div>

      <div>
        <label class="font-normal required" for="cdsCode">{{ t('agencies.fields.agencyCode') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('agencies.fields.agencyCodeRequiredPlaceholder')" autocomplete="off" id="cdsCode" type="text"
            formControlName="cdsCode" maxlength="25" required>
        </mat-form-field>
      </div>

      <div class="select-input flex-col justify-center items-center">
        <drdp-select-site-code [initialCodeId]="codeType.value" (code)="onDropDownSelect($event, selectType.CodeType)"
          [isValid]="!codeType.touched || codeType.valid" [required]="true">
        </drdp-select-site-code>
      </div>

      <div class="select-input flex-col justify-center items-center">
        <drdp-select-state [initialStateId]="stateId.value" (state)="onDropDownSelect($event, selectType.States)"
          [isValid]="!stateId.touched || stateId.valid" [required]="true" [disabled]="!!stateId.value && editData?.data?.id">
        </drdp-select-state>
      </div>

      <div class="select-input flex-col justify-center items-center">
        <drdp-select-type [initialTypeId]="typeId.value" (type)="onDropDownSelect($event, selectType.SiteType)"
          [required]="true" [isValid]="!typeId.touched || typeId.valid">
        </drdp-select-type>
      </div>

      <div class="col-span-2 ">
        <label class="font-normal" for="footer">{{ t('agencies.fields.footer') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('agencies.fields.footer')" autocomplete="off" id="footer" type="text" formControlName="footer"
            [maxLength]="250">
        </mat-form-field>
      </div>

      <div>
        <label class="font-normal required" for="agencyAdress">{{ t('agencies.fields.agencyAddress') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('agencies.fields.agencyAddress')" autocomplete="off" id="agencyAdress" type="text"
            formControlName="agencyAddress" maxlength="100" required>
        </mat-form-field>
      </div>

      <div>
        <label class="font-normal required" for="agencyCity">{{ t('agencies.fields.agencyCity') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('agencies.fields.agencyCity')" autocomplete="off" id="agencyCity" type="text"
            formControlName="agencyCity" maxlength="25" required>
        </mat-form-field>
      </div>

      <div class="input-container">
        <drdp-select-county [initialCountyIds]="countyId.value" (county)="onDropDownSelect($event, selectType.County)"
          [stateId]="stateId.value" [multiSelect]="false" [multiSelectInitVals]="false"
          [isValid]="!countyId.touched || countyId.valid" [required]="stateId?.value == states.california">
        </drdp-select-county>
      </div>

      <div>
        <label class="font-normal required" for="agencyZipCode">{{ t('agencies.fields.agencyZipCode') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('agencies.fields.agencyZipCode')" autocomplete="off" id="agencyZipCode" type="text"
            formControlName="agencyZipCode" maxlength="10" required>
        </mat-form-field>
      </div>

      <div>
        <drdp-select-region [stateId]="stateId.value" [initialRegionId]="regionIds.value" [multiSelectInitVals]="true"
          [multiSelect]="true" [isValid]="!regionIds.touched || regionIds.valid"
          (region)="onDropDownSelect($event, selectType.RegionRef)">
        </drdp-select-region>
      </div>

      <div class="select-input flex-col justify-center items-center">
        <drdp-select-vendor [initialVendorIds]="vendorIds.value" [multiSelectInitVals]="true" [multiSelect]="true"
          (vendor)="onDropDownSelect($event, selectType.VendorRef)" [required]="true"
          [isValid]="!vendorIds.touched || vendorIds.valid">
        </drdp-select-vendor>
      </div>

      <div class="select-input flex-col jusityf-center items-center">
        <drdp-select-head-start label="Head Start"
          [initialheadStartId]="headStartId.value"
          (headStart)="onHeadStartSelect($event)"
          [stateId]="stateId.value">
        </drdp-select-head-start>
      </div>

      @if (headStartId.value && headStartId.value == HeadStart.HeadStartDelegate) {
        <div class="select-input flex-col justify-center items-center"
          >
          <drdp-select-grantee [initialGranteeId]="granteeAgencyId.value"
            [intialAgencyId]="editData.data?.id"
            [label]="t('agencies.fields.headStartGranteeAgency')"
            (agency)="onDropDownSelect($event, selectType.HeadStartGranteeRef)"
            [required]="true"
            [stateId]="stateId.value">
          </drdp-select-grantee>
        </div>
      }

      <div class="select-input flex-col jusityf-center items-center">
        <drdp-select-state-preschool label="State Preschool"
          [initialStatePreschoolId]="statePreschoolId.value"
          (statePreschool)="onStatePreschoolSelect($event)"
          [stateId]="stateId.value">
        </drdp-select-state-preschool>
      </div>

      @if (statePreschoolId.value && statePreschoolId.value == StatePreschool.StatePreschoolSubcontractor) {
        <div class="select-input flex-col justify-center items-center"
          >
          <drdp-select-contractor [initialContractorId]="contractorAgencyId.value"
            [intialAgencyId]="editData.data?.id"
            [label]="t('agencies.fields.statePreschoolContractorAgency')"
            (agency)="onDropDownSelect($event, selectType.StatePreschoolContractorRef)"
            [required]="true"
            [stateId]="stateId.value">
          </drdp-select-contractor>
        </div>
      }

    </form>

  </div>
  <div class="spacer"></div>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <drdp-btn color="cancel" class="mr-2" mat-button mat-dialog-close (click)="cancel()">{{ t('common.cancel') }}</drdp-btn>
    <drdp-btn mat-button [disabled]="agencyForm.invalid || isProcessing" cdkFocusInitial
    (click)="onSubmit()">{{ t('common.save') }}</drdp-btn>
  </div>
</div>
</ng-container>
